'use client';

import React, { useState } from 'react';
import FounderForm from './FounderForm';
import InvestorForm from './InvestorForm';
import PartnersForm from './PartnersForm';

const tabs = [
  { id: 'founders', label: 'Raising Capital?' },
  { id: 'investors', label: 'Looking to Invest?' },
  { id: 'partners', label: 'Work with Aregn?' },
];

export default function ContactTabs() {
  const [activeTab, setActiveTab] = useState<string>('founders');

  return (
    <section className="py-12 px-6 pb-24">
      <div className="max-w-4xl mx-auto">
        {/* Tab switcher */}
        <div className="flex flex-wrap gap-2 justify-center mb-12 p-1.5 rounded-full border border-primary/20 bg-card/40 backdrop-blur-sm w-fit mx-auto">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`px-5 py-2.5 rounded-full text-xs font-semibold tracking-widest uppercase transition-all duration-300 ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground shadow-lg'
                  : 'text-muted-foreground hover:text-foreground hover:bg-primary/10'
              }`}
            >
              {tab?.label}
            </button>
          ))}
        </div>

        {/* Tab content */}
        <div>
          {activeTab === 'founders' && <FounderForm />}
          {activeTab === 'investors' && <InvestorForm />}
          {activeTab === 'partners' && <PartnersForm />}
        </div>
      </div>
    </section>
  );
}
